<template>
  <div class="d-none d-xl-flex d-lg-flex">
    <v-badge
      v-if="badge"
      :content="badgeContent"
      color="error"
      overlap
      offset-x="8"
      offset-y="8"
    >
      <v-btn
        fab
        small
        elevation="0"
        color="white"
        class="mx-2 circular-btn"
        style="width: 40px; height: 40px; min-width: 40px;"
        v-bind="$attrs"
      >
        <v-icon :color="iconColor" :size="iconSize">
          {{ icon }}
        </v-icon>
      </v-btn>
    </v-badge>
    <v-btn
      v-else
      fab
      small
      elevation="0"
      color="white"
      class="mx-2 circular-btn"
      style="width: 40px; height: 40px; min-width: 40px;"
      v-bind="$attrs"
    >
      <v-icon :color="iconColor" :size="iconSize">
        {{ icon }}
      </v-icon>
    </v-btn>
  </div>
</template>

<script setup>
defineProps({
  icon: {
    type: String,
    required: true
  },
  iconColor: {
    type: String,
    default: 'primary'
  },
  iconSize: {
    type: Number,
    default: 24
  },
  badge: {
    type: Boolean,
    default: false
  },
  badgeContent: {
    type: [String, Number],
    default: ''
  }
});
</script>

<style scoped>
.circular-btn {
  background-color: white !important;
  border-radius: 50% !important;
}
</style>
